import React from 'react';
import { motion } from 'framer-motion';
import ProjectCard from './ProjectCard';

interface ProjectGridProps {
  limit?: number;
}

interface Project {
  id: string;
  title: string;
  description: string;
  image: string;
  backgroundClass?: string;
  backgroundImage?: string;
  ambientGradients?: boolean;
  tags: string[];
}

const ProjectGrid: React.FC<ProjectGridProps> = ({ limit }) => {
  const projects: Project[] = [
    {
      id: 'autotune',
      title: 'AutoTune',
      description: 'Precise vocal editing and pitch correction.',
      image: '',
      backgroundClass: 'relative bg-zinc-100 dark:bg-zinc-900 overflow-hidden rounded-lg',
      ambientGradients: true,
      tags: ['Product Design', 'Music Tech', 'In Progress']
    },
    {
      id: 'tuney',
      title: 'Tuney',
      description: 'Increased retention by 23% and paid conversions by 10%.',
      image: '/images/tuney-feature.png',
      backgroundClass: 'relative bg-zinc-100 dark:bg-zinc-900 overflow-hidden rounded-lg',
      ambientGradients: true,
      tags: ['Full Redesign', 'Music AI', 'Web App']
    },
    {
      id: 'bace',
      title: 'Bace',
      description: 'Patented voice-to-MIDI software used by 450+ musicians.',
      image: '/images/home-bace.png',
      backgroundClass: 'overflow-hidden rounded-lg bg-gradient-to-tr from-[#FE4D1C] to-[#F7B733]',
      tags: ['0 → 1 Design', 'Music AI', 'Desktop App & Plug-in']
    },
    {
      id: 'brewerydb',
      title: 'BreweryDB',
      description: '25% increase in new user accounts with route planning.',
      image: '/images/brewerydb-feature-devices.png',
      backgroundClass: "overflow-hidden rounded-lg",
      backgroundImage: '/images/brewerydb-feature-bg.png',
      tags: ['0 → 1 Design', 'Map Design', 'iOS & Android']
    },
    {
      id: 'cbyon',
      title: 'CBYON',
      description: 'Top-three surgical navigation tool in clinical feedback.',
      image: '/images/cbyon-feature2.png',
      backgroundClass: "bg-cyan-700 overflow-hidden rounded-lg",
      backgroundImage: '/images/cbyon-feature-bg.png',
      tags: ['Full Redesign', 'Scalable System', 'Software & Robotics']
    },
    {
      id: 't-mobile',
      title: 'T-Mobile',
      description: 'Limited-edition 5Gin sold out in minutes.',
      image: '/images/t-mobile-feature.png',
      backgroundClass: 'overflow-hidden rounded-lg',
      tags: ['Style Guided Design', 'Augmented Reality', 'Landing Page']
    }
  ];

  const displayProjects = limit ? projects.slice(0, limit) : projects;

  return (
    <>
      {displayProjects.map((project, index) => {
        const card = (
          <ProjectCard
            id={project.id}
            title={project.title}
            description={project.description}
            image={project.image}
            backgroundClass={project.backgroundClass}
            backgroundImage={project.backgroundImage}
            ambientGradients={project.ambientGradients}
            tags={project.tags}
          />
        );

        return (
          <motion.div
            className="md:col-span-6 lg:col-span-4"
            key={project.id}
            initial={{ opacity: 0, y: project.ambientGradients ? 0 : -3 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.3,
              ease: 'easeOut',
              delay: index * 0.1,
            }}
            viewport={{ once: true, amount: 0.0 }}
          >
            {card}
          </motion.div>
        );
      })}
      
    </>
  );
};

export default ProjectGrid;
